import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Box from 'components/Box';
function Divider(props) {
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%"
  }, props, {
    height: "1px",
    background: "border"
  }));
}
Divider.displayName = 'Divider';
export default Divider;